export interface Article {
  id: number;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  image: string;
  date: string;
  views: number;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: 1,
    title: "2026年最值得期待的十大国产电影",
    excerpt: "盘点今年即将上映的国产大片，从悬疑到科幻，从爱情到动作，总有一部适合你。",
    content: `<p>2026年国产电影市场持续火热，多部备受期待的大片即将与观众见面。以下是我们精心挑选的十部最值得期待的国产电影：</p>
<h3>1. 《深海迷踪》</h3>
<p>由知名导演张导执导的科幻悬疑大片，讲述一支深海探险队在万米海底发现神秘遗迹的故事。影片投资超过5亿，特效制作精良，是今年最受关注的国产科幻巨制。</p>
<h3>2. 《长安十二时辰之凤凰劫》</h3>
<p>改编自马伯庸同名小说的历史悬疑片，延续了前作的精良制作，这次的故事更加宏大，场景更加壮观。</p>
<h3>3. 《流浪地球3》</h3>
<p>中国科幻电影的里程碑系列第三部，故事将带领观众走向更加遥远的星际旅程，吴京、刘德华等原班人马回归。</p>
<p>此外还有多部类型各异的优秀作品等待上映，国产电影正在迎来最好的时代。</p>`,
    category: "movie",
    image: "https://readdy.ai/api/search-image?query=Cinema%20movie%20theater%20interior%20with%20red%20curtains%20and%20spotlight%2C%20dramatic%20atmosphere%2C%20film%20premiere%20vibe%2C%20warm%20golden%20lighting%2C%20elegant%20composition%2C%20Hollywood%20style%2C%20clean%20background&width=800&height=500&seq=article-01&orientation=landscape",
    date: "2026-07-28",
    views: 15820,
    tags: ["电影推荐", "国产电影", "2026大片"]
  },
  {
    id: 2,
    title: "全网最详细91影视看片APP安装教程",
    excerpt: "手把手教你下载和安装91影视看片APP，三分钟轻松搞定，安卓手机用户必看。",
    content: `<p>91影视看片APP是目前最受欢迎的免费影视APP之一，支持海量影视资源在线观看和离线下载。以下是详细的安装教程：</p>
<h3>第一步：下载安装包</h3>
<p>访问91影视看片下载官网，点击"安卓APP免费下载"按钮，下载最新版本的APK安装包。注意请务必从官方渠道下载，避免下载到带有病毒或广告的盗版版本。</p>
<h3>第二步：允许安装未知来源应用</h3>
<p>下载完成后，打开手机设置，进入"安全"或"隐私"选项，开启"允许安装未知来源应用"的权限。不同品牌手机的设置路径可能略有不同。</p>
<h3>第三步：安装APP</h3>
<p>点击下载好的APK文件，按照屏幕提示完成安装。安装过程大约需要30秒到1分钟。</p>
<h3>第四步：开始使用</h3>
<p>安装完成后，打开91影视看片APP，无需注册登录即可直接浏览和观看海量影视内容。你也可以将喜欢的影片缓存到本地，随时随地离线观看。</p>`,
    category: "hot",
    image: "https://readdy.ai/api/search-image?query=Smartphone%20screen%20displaying%20movie%20streaming%20app%20interface%2C%20modern%20mobile%20app%20design%2C%20clean%20UI%2C%20warm%20lighting%2C%20hand%20holding%20phone%2C%20minimalist%20composition%2C%20soft%20background&width=800&height=500&seq=article-02&orientation=landscape",
    date: "2026-07-25",
    views: 32650,
    tags: ["安装教程", "APP下载", "使用指南"]
  },
  {
    id: 3,
    title: "今年评分最高的五部国产电视剧",
    excerpt: "豆瓣高分国产剧推荐，从古装权谋到现代都市，每一部都值得追。",
    content: `<p>2026年上半年国产电视剧市场佳作频出，我们整理了豆瓣评分最高的五部作品：</p>
<h3>1. 《繁城之下》 - 豆瓣9.2分</h3>
<p>一部以明代江南为背景的古装悬疑剧，制作精良，剧情扣人心弦。演员演技在线，服化道考究，是今年古装剧的标杆之作。</p>
<h3>2. 《漫长的季节2》 - 豆瓣9.0分</h3>
<p>延续第一季的高品质，辛爽导演再次用独特的叙事手法讲述了一个关于家庭与救赎的故事。</p>
<h3>3. 《开端2》 - 豆瓣8.8分</h3>
<p>时间循环题材的又一次成功尝试，新一季的故事更加烧脑，演员表现更加出色。</p>`,
    category: "tv",
    image: "https://readdy.ai/api/search-image?query=Chinese%20TV%20drama%20scene%20with%20historical%20costumes%20and%20elegant%20setting%2C%20cinematic%20lighting%2C%20warm%20amber%20tones%2C%20traditional%20Chinese%20aesthetic%2C%20film%20quality%20photography%2C%20clean%20composition&width=800&height=500&seq=article-03&orientation=landscape",
    date: "2026-07-20",
    views: 22100,
    tags: ["电视剧推荐", "豆瓣高分", "国产剧"]
  },
  {
    id: 4,
    title: "91影视看片APP五大隐藏功能揭秘",
    excerpt: "用了这么久，你可能还不知道这些实用功能，让你的观影体验提升一个档次。",
    content: `<p>91影视看片APP除了基础的在线播放和离线下载功能外，还有很多实用的隐藏功能等待你发现：</p>
<h3>1. 倍速播放</h3>
<p>在播放界面长按屏幕右侧，可以调出倍速播放菜单，支持0.5倍到2倍速播放，追剧效率翻倍。</p>
<h3>2. 定时关闭</h3>
<p>睡前追剧必备功能。在播放设置中可以开启定时关闭，设定15分钟、30分钟、60分钟后自动停止播放。</p>
<h3>3. 画面比例调节</h3>
<p>双指在播放界面缩放，可以自由调节画面比例，支持全屏、原始比例、填充屏幕三种模式。</p>
<h3>4. 字幕切换</h3>
<p>支持在线匹配中文字幕，也可以导入本地字幕文件，满足不同观看需求。</p>
<h3>5. 投屏功能</h3>
<p>点击播放器右上角的投屏图标，可以将手机画面投射到智能电视上，享受大屏观影体验。</p>`,
    category: "hot",
    image: "https://readdy.ai/api/search-image?query=Smartphone%20displaying%20video%20player%20app%20with%20various%20control%20buttons%2C%20modern%20mobile%20interface%2C%20clean%20design%2C%20warm%20lighting%2C%20technology%20lifestyle%2C%20minimalist%20composition&width=800&height=500&seq=article-04&orientation=landscape",
    date: "2026-07-18",
    views: 18900,
    tags: ["使用技巧", "隐藏功能", "APP教程"]
  },
  {
    id: 5,
    title: "2026年暑期档最火综艺节目盘点",
    excerpt: "暑期综艺大战全面开启，音乐竞演、真人秀、脱口秀应有尽有。",
    content: `<p>2026年暑期档综艺市场热闹非凡，各大平台纷纷推出重磅综艺节目：</p>
<h3>《歌手2026》</h3>
<p>经典音乐竞演节目重磅回归，全新赛制和豪华阵容引发全网热议。那英、华晨宇、邓紫棋等实力唱将同台竞技。</p>
<h3>《奔跑吧》第十二季</h3>
<p>国民综艺长青树，新一季加入多位新成员，节目形式也在不断创新，笑点密集。</p>
<h3>《脱口秀大会》第六季</h3>
<p>喜剧新势力的舞台，今年涌现出多位实力派新人，段子质量极高。</p>`,
    category: "variety",
    image: "https://readdy.ai/api/search-image?query=Colorful%20TV%20variety%20show%20stage%20with%20musical%20performance%2C%20bright%20stage%20lighting%2C%20energetic%20atmosphere%2C%20entertainment%20studio%2C%20vibrant%20colors%2C%20dynamic%20composition%2C%20clean%20background&width=800&height=500&seq=article-05&orientation=landscape",
    date: "2026-07-15",
    views: 14500,
    tags: ["综艺推荐", "暑期档", "音乐竞演"]
  },
  {
    id: 6,
    title: "豆瓣9分以上必看动漫推荐",
    excerpt: "精选十部豆瓣评分9.0以上的经典动漫，动漫爱好者不容错过。",
    content: `<p>动漫作品中有很多评分极高的经典之作，以下是豆瓣评分9.0以上的十部必看动漫：</p>
<h3>1. 《进击的巨人》最终季 - 豆瓣9.8分</h3>
<p>现象级动漫作品的完美收官，MAPPA制作精良，剧情震撼人心。</p>
<h3>2. 《鬼灭之刃 游郭篇》 - 豆瓣9.5分</h3>
<p>UFOtable的精湛制作让每一帧都堪称壁纸级别，战斗场面燃到极致。</p>
<h3>3. 《葬送的芙莉莲》 - 豆瓣9.4分</h3>
<p>一部关于时间、生命与羁绊的治愈系作品，温柔的叙事让人感受到生命的重量。</p>`,
    category: "anime",
    image: "https://readdy.ai/api/search-image?query=Anime%20art%20style%20illustration%20with%20fantasy%20adventure%20theme%2C%20beautiful%20detailed%20characters%2C%20soft%20warm%20lighting%2C%20Japanese%20animation%20aesthetic%2C%20cinematic%20composition%2C%25clean%20background&width=800&height=500&seq=article-06&orientation=landscape",
    date: "2026-07-12",
    views: 19300,
    tags: ["动漫推荐", "豆瓣高分", "日漫"]
  },
  {
    id: 7,
    title: "91影视看片APP与其他影视APP对比评测",
    excerpt: "全面对比市面上主流影视APP，看看91影视看片有哪些优势。",
    content: `<p>市面上影视APP众多，我们选择了四款主流产品进行全面对比：</p>
<h3>资源丰富度对比</h3>
<p>91影视看片APP覆盖电影、电视剧、综艺、动漫、纪录片五大品类，资源数量超过10万部，远超同类产品。</p>
<h3>播放体验对比</h3>
<p>91影视看片采用P2P加速技术，在同等网络环境下，加载速度和播放流畅度明显优于竞品。</p>
<h3>价格对比</h3>
<p>91影视看片完全免费，无需会员订阅。而其他主流APP普遍需要每月15-30元的会员费。</p>
<h3>综合评价</h3>
<p>综合资源、体验、价格三个维度，91影视看片APP是目前性价比最高的选择。</p>`,
    category: "hot",
    image: "https://readdy.ai/api/search-image?query=Comparison%20chart%20of%20mobile%20apps%20on%20smartphone%20screens%2C%20modern%20technology%20comparison%2C%20clean%20minimalist%20design%2C%20warm%20lighting%2C%20product%20review%20theme%2C%20professional%20composition&width=800&height=500&seq=article-07&orientation=landscape",
    date: "2026-07-10",
    views: 25100,
    tags: ["对比评测", "影视APP", "推荐"]
  },
  {
    id: 8,
    title: "自然纪录片《地球脉动3》深度解析",
    excerpt: "BBC史诗级纪录片回归，4K画质带你领略地球最壮丽的自然奇观。",
    content: `<p>《地球脉动》系列是BBC自然历史部打造的里程碑式纪录片。第三季时隔十年终于回归，再次刷新了我们对纪录片的认知。</p>
<h3>制作规模</h3>
<p>历时四年拍摄，足迹遍布七大洲40多个国家，使用了最先进的8K摄影机和无人机技术。</p>
<h3>精彩内容</h3>
<p>从深海到沙漠，从极地到热带雨林，展示了地球上最令人惊叹的自然奇观和动物行为。每一帧画面都堪称艺术品。</p>
<h3>观看建议</h3>
<p>建议使用91影视看片APP投屏到4K电视观看，才能充分体验这部纪录片的震撼画面。</p>`,
    category: "doc",
    image: "https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20scene%20with%20wildlife%20and%20beautiful%20landscape%2C%20golden%20sunlight%2C%20National%20Geographic%20style%2C%20professional%20wildlife%20photography%2C%20warm%20earthy%20tones%2C%20cinematic%20composition%2C%20clean%20background&width=800&height=500&seq=article-08&orientation=landscape",
    date: "2026-07-08",
    views: 12100,
    tags: ["纪录片", "BBC", "自然"]
  }
];

export const features = [
  {
    icon: "ri-database-2-line",
    title: "海量资源",
    desc: "覆盖电影、电视剧、综艺、动漫、纪录片等全品类影视内容，每日更新不断片",
  },
  {
    icon: "ri-4k-line",
    title: "高清画质",
    desc: "支持1080P超清画质播放，智能适配网络环境，流畅不卡顿",
  },
  {
    icon: "ri-money-dollar-circle-line",
    title: "完全免费",
    desc: "无需会员、无需付费，所有影视资源免费观看，真正的免费看片软件",
  },
  {
    icon: "ri-download-cloud-2-line",
    title: "离线下载",
    desc: "支持一键离线缓存，无网络也能随时随地观看，地铁飞机都能看",
  },
  {
    icon: "ri-speed-up-line",
    title: "极速播放",
    desc: "采用P2P加速技术，播放速度更快更稳定，告别缓冲等待",
  },
  {
    icon: "ri-shield-check-line",
    title: "纯净体验",
    desc: "无广告干扰，界面简洁清爽，专注观影体验",
  }
];

export const reviews = [
  {
    name: "王先生",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20man%20in%20business%20attire%2C%20warm%20smile%2C%20clean%20studio%20background%2C%20soft%20lighting%2C%20natural%20expression&width=100&height=100&seq=avatar-01&orientation=squarish",
    content: "用了91影视看片半年多了，资源更新真的快，新电影基本上上映一周就能在APP上看到。画质也很清晰，推荐！",
    rating: 5,
    date: "2026-07-30"
  },
  {
    name: "李女士",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20woman%20with%20warm%20smile%2C%20clean%20studio%20background%2C%20soft%20natural%20lighting%2C%20professional%20attire&width=100&height=100&seq=avatar-02&orientation=squarish",
    content: "之前用其他APP都要充会员，91影视完全免费真的太良心了。离线下载功能也很好用，通勤路上追剧神器。",
    rating: 5,
    date: "2026-07-28"
  },
  {
    name: "张同学",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Asian%20student%20portrait%20with%20casual%20style%2C%20friendly%20smile%2C%20clean%20studio%20background%2C%20soft%20lighting%2C%20natural%20expression&width=100&height=100&seq=avatar-03&orientation=squarish",
    content: "作为学生党，免费影视APP真的太友好了。动画片资源特别全，追番必备，强烈推荐给同学们！",
    rating: 5,
    date: "2026-07-25"
  }
];